import "./index.scss";
import React from 'react';
import { Modal } from "react-bootstrap";
import { Link } from 'react-router-dom';

function StatusModal({ showStatusModal, setShowStatusModal, subscriptionFnc }) {
    const handleClose = ()=>{
        subscriptionFnc();
        setShowStatusModal({ isOpen: false, type: null });
    }
    return (
        <>
            <Modal
                show={showStatusModal.isOpen}
                onHide={() => handleClose()}
                keyboard={false}
                size="md"
                className="add-travellers-modal"
                centered
            >
                <Modal.Body>
                    <div className="cmn-card-info-block text-center payment-sf-block">
                        {showStatusModal?.type === "success" && (
                            <div className="cmn-card-info-content payment-successful">
                                <i className="bi bi-check-circle-fill"></i>
                                <h3>Welcome & Thank you</h3>
                                <p>Thank you for subscribing! we are so excited to welcome you.</p>
                                <Link to="admin/manage-subscription" className="btn btn-primary-color mt-4"><span className="bi bi-arrow-left-short"></span> Back to Subscriptions</Link>
                            </div>
                        )}
                        {showStatusModal?.type === "failure" && (
                            <div className="cmn-card-info-content payment-cancelled">
                                <i className="bi bi-exclamation-circle-fill"></i>
                                <h3>Error</h3>
                                <p>Unfortunately we have an issue with your payment, try again later.</p>
                                <Link to="/" className="btn btn-primary-color mt-4"><span className="bi bi-arrow-left-short"></span> Continue</Link>
                            </div>
                        )}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default StatusModal;
